import { frontendURL } from "dashboard/helper/URLHelper.js";
import { ROLES } from "dashboard/constants/permissions.js";

const AnnouncementsIndex = () => import("./AnnouncementsIndex.vue");
const AnnouncementsCompose = () => import("./Compose.vue");

export default {
  routes: [
    {
      path: frontendURL("accounts/:accountId/settings/announcements"),
      name: "announcements_index",
      meta: {
        permissions: ROLES,
      },
      component: AnnouncementsIndex,
    },
    {
      path: frontendURL("accounts/:accountId/settings/announcements/new"),
      name: "announcements_compose",
      meta: {
        // 'super_admin' es un permiso sintético elevado en permissionsHelper.js
        // para cualquier User con type SuperAdmin, independiente de su rol en
        // la cuenta activa — necesario porque puede publicar sin ser miembro.
        permissions: ["administrator", "super_admin"],
      },
      component: AnnouncementsCompose,
    },
    {
      path: frontendURL("accounts/:accountId/settings/announcements/:id/edit"),
      name: "announcements_edit",
      meta: {
        permissions: ["administrator", "super_admin"],
      },
      component: AnnouncementsCompose,
      props: true,
    },
  ],
};
